import { render, staticRenderFns } from "./salesRanking.vue?vue&type=template&id=518709b8&scoped=true"
import script from "./salesRanking.vue?vue&type=script&lang=js"
export * from "./salesRanking.vue?vue&type=script&lang=js"
import style0 from "./salesRanking.vue?vue&type=style&index=0&id=518709b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518709b8",
  null
  
)

export default component.exports